import { createRouter, createWebHistory } from 'vue-router';
import { useVault } from './stores/vault.js';

const routes = [
  { path: '/', redirect: '/add' },
  { path: '/add', name: 'add', component: () => import('./views/AddView.vue') },
  { path: '/find', name: 'find', component: () => import('./views/FindView.vue') },
  { path: '/shelf', name: 'shelf', component: () => import('./views/ShelfView.vue') },
  { path: '/connect', name: 'connect', component: () => import('./views/ConnectView.vue') },
  { path: '/people', name: 'people', component: () => import('./views/PeopleView.vue') },
  // Full screen, its own chrome, opened in its own tab from the shelf.
  { path: '/tool/:id', name: 'tool', component: () => import('./views/ToolView.vue') },

  { path: '/signin', name: 'signin', component: () => import('./views/SignIn.vue'), meta: { open: true } },
  { path: '/set-password', name: 'set-password', component: () => import('./views/SetPassword.vue'), meta: { open: true } },
  { path: '/oauth/consent', name: 'consent', component: () => import('./views/Consent.vue') },
  { path: '/:pathMatch(.*)*', redirect: '/add' },
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior: () => ({ top: 0 }),
});

router.beforeEach(async to => {
  const vault = useVault();
  if (!vault.loaded) await vault.load();
  if (to.meta.open) return true;
  if (!vault.signedIn) return { name: 'signin', query: { next: to.fullPath } };
  return true;
});
